import {
  createBrowserRouter,
  RouterProvider
} from "react-router-dom";

import "../index.css";
import DappierAnswerPageLoader  from "../components/DappierAnswerPageLoader";

const router = createBrowserRouter([
  {
    path: "/",
    Component: DappierAnswerPageLoader,
  }
]);

// Hot Module Replacement (HMR) support for both Vite and Webpack/CRA
if (import.meta.hot) {
  import.meta.hot.dispose(() => router.dispose());
}

if (typeof module !== 'undefined' && module.hot) {
  module.hot.dispose(() => router.dispose());
}

export function Fallback() {
    return <p>Performing initial data load</p>;
  }

export default function App() {
    return <RouterProvider router={router} fallbackElement={<Fallback />} />;
  }
  
